import { styled } from '@mui/material/styles';

interface IRootProps {
	variant?: string;
	spacing: 'S' | 'M';
}

export const Root = styled('button', {
	shouldForwardProp: (prop) => !['variant', 'spacing'].includes(prop as string),
})<IRootProps>(({ theme, variant, spacing }) => ({
	outline: 'none',
	cursor: 'pointer',
	color: theme.palette.primary.main,
	padding: spacing === 'M' ? 16 : '7.5px 16px',
	boxSizing: 'border-box',
	border: '1px solid transparent',
	borderRadius: 8,
	transition: 'border .2s ease',
	backgroundColor:
		(variant === 'grey' && theme.palette.neutral[40]) ||
		theme.palette.neutral[0],
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr max-content',
	alignItems: 'center',
	width: '100%',

	'@media (hover: hover) and (pointer: fine)': {
		'&:hover': {
			borderColor: theme.palette.neutral[80],
		},
	},

	'& .mainIcon': {
		marginRight: 16,
		'& svg': {
			display: 'block',
		},
	},

	'& .label': {
		textAlign: 'left',
		gridColumnStart: 2,
	},

	'& .helperIcon': {
		gridColumnStart: -2,
		marginLeft: 16,

		'& svg': {
			display: 'block',
		},
	},

	'&:disabled': {
		'&, .label, .helper': {
			color: theme.palette.neutral[60],
		},
	},
}));
